import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { LimitOffsetPaging } from '../../../core/models/paged-results/limit-offset-paging.model';
import { ActivatedRoute, Router } from '@angular/router';
import { DecimalPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-pagination-header',
    templateUrl: './pagination-header.component.html',
    styleUrls: ['./pagination-header.component.scss'],
    imports: [FormsModule, DecimalPipe]
})
export class PaginationHeaderComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  @Input() paging: LimitOffsetPaging;
  @Input() label: string;
  @Input() updateUrl = false;
  @Input() allowLargeSize = false;
  @Input() includeResetFiltersButton = false;

  pageSizes = [5, 10, 20, 50, 100];

  @Output() public pageSizeChange = new EventEmitter<number>();
  @Output() public resetFiltersClick = new EventEmitter<void>();

  get viewing() {
    return Math.min(this.paging.pageSize, this.paging.count);
  }

  get visible() {
    return this.includeResetFiltersButton || this.paging.count > Math.min(...this.pageSizes);
  }

  ngOnInit() {
    if (this.allowLargeSize) this.pageSizes.push(500);
  }

  onPageSizeChange(event) {
    const size = event.target.value;
    this.updatePageSizeParam(size);
    this.pageSizeChange.emit(size);
  }

  onResetFiltersClick($event) {
    $event.preventDefault();
    this.resetFiltersClick.emit();
  }

  private updatePageSizeParam(size) {
    if (this.updateUrl) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { pageSize: size },
        queryParamsHandling: 'merge',
      });
    }
  }
}
